import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onSearch", "onChange", "name", "id", "icon", "hideDropdownIndicator", "openMenuOnClick", "isMulti", "valueRenderType"];
import { Search } from "lucide-react";
import React from "react";
import AsyncSelect from "../AsyncSelect";
import useGetCustomComponents from "../hooks/useGetCustomComponents";
import { jsx as _jsx } from "react/jsx-runtime";
var SearchSelectInput = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var onSearch = _ref.onSearch,
    onChange = _ref.onChange,
    name = _ref.name,
    id = _ref.id,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? Search : _ref$icon,
    _ref$hideDropdownIndi = _ref.hideDropdownIndicator,
    hideDropdownIndicator = _ref$hideDropdownIndi === void 0 ? true : _ref$hideDropdownIndi,
    _ref$openMenuOnClick = _ref.openMenuOnClick,
    openMenuOnClick = _ref$openMenuOnClick === void 0 ? false : _ref$openMenuOnClick,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
    _ref$valueRenderType = _ref.valueRenderType,
    valueRenderType = _ref$valueRenderType === void 0 ? "default" : _ref$valueRenderType,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useGetCustomComponen = useGetCustomComponents({
      hideDropdownIndicator: hideDropdownIndicator,
      component: "searchSelectInput",
      valueRenderType: valueRenderType
    }),
    customComponents = _useGetCustomComponen.customComponents;
  return /*#__PURE__*/_jsx(AsyncSelect, _extends({
    onChange: onChange,
    onSearch: onSearch,
    name: name,
    openMenuOnClick: openMenuOnClick,
    id: id,
    ref: forwardedRef,
    leftAdornmentIcon: icon,
    hideDropdownIndicator: true,
    isMulti: isMulti,
    valueRenderType: valueRenderType,
    components: customComponents // custom inner components
    ,
    icon: icon
  }, restProps));
});
SearchSelectInput.displayName = "SearchSelectInput";
export default SearchSelectInput;